var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notification_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "notification_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,17.5 C10,18.6 9.1,19.5 8,19.5 C6.89,19.5 6,18.6 6,17.5 Z M8,0 C8.83,0 9.5,0.67 9.5,1.5 L9.5,2.18 C12.36,2.86 14,5.43 14,8.5 L14,13.5 L16,15.5 L16,16.5 L0,16.5 L0,15.5 L2,13.5 L2,8.5 C2,5.42 3.63,2.86 6.5,2.18 L6.5,1.5 C6.5,0.67 7.17,0 8,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.0 -923.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notification_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.9999999999986 923.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notification_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16,0 16,19.5 0,19.5 0,0",
    stroke: "none"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e62c6c25c6c2e8cc2ab9e9a78bce47c0.svg";
export { ForwardRef as ReactComponent };